// firebase components
import { collection, getFirestore, getDocs, query, limit } from "firebase/firestore";

// Ajce Hostel App React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import MDAvatar from "components/MDAvatar";

import { Link } from "react-router-dom";

// react components
import { useState, useEffect } from "react";
import MDBadge from "components/MDBadge";
import { useNavigate } from "react-router-dom";
import { useMaterialUIController } from "context";
import { Button } from "@mui/material";
import MDButton from "components/MDButton";

const firestore = getFirestore();

export default function useStudentsListData() {
  const [studentData, setStudentData] = useState([]);
  const navigate = useNavigate();
  const [uicontrol] = useMaterialUIController();

  useEffect(() => {
    (async () => {
      const studentsSnapshot = await getDocs(
        query(collection(firestore, "students_partial"), limit(7))
      );
      studentsSnapshot.forEach((doc) => {
        const student = doc.data();
        const row = {
          admno: student.admissionNo,
          student: <Student image={student.imgLink} name={student.name} email={student.email} />,
          inout: (
            <MDBox ml={-1}>
              <MDBadge
                badgeContent={student.isIn ? "In" : "Out"}
                color={student.isIn ? "success" : "error"}
                variant="gradient"
                size="sm"
              />
            </MDBox>
          ),
          admissionNo: (
            <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
              {student.admissionNo}
            </MDTypography>
          ),
          room: (
            <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
              {student.roomNo}
            </MDTypography>
          ),
          sem: (
            <MDTypography component="a" href="#" variant="caption" color="text" fontWeight="medium">
              {student.sem}
            </MDTypography>
          ),

          viewProfile: (
            <Link to={`/students/profile/${student.admissionNo}`}>
              <MDButton variant="gradient" color={uicontrol.sidenavColor}>
                View
              </MDButton>
            </Link>
          ),
        };
        setStudentData((studentData) => [...studentData, row]);
      });
    })();
  }, [setStudentData]);

  useEffect(() => {
    setStudentData((prev) => {
      prev?.forEach((data) => {
        data.viewProfile = (
          <MDButton
            type="submit"
            variant="gradient"
            color={uicontrol.sidenavColor}
            onClick={() => {
              navigate(`/students/profile/${data.admno}`);
            }}
          >
            View
          </MDButton>
        );
      });
      return [...prev];
    });
  }, [setStudentData, uicontrol.sidenavColor]);

  const Student = ({ image, name, email }) => (
    <MDBox display="flex" alignItems="center" lineHeight={1}>
      <MDAvatar src={image} name={name} size="sm" />
      <MDBox ml={2} lineHeight={1}>
        <MDTypography display="block" variant="button" fontWeight="medium">
          {name}
        </MDTypography>
        <MDTypography variant="caption">{email}</MDTypography>
      </MDBox>
    </MDBox>
  );

  return {
    columns: [
      { Header: "student", accessor: "student", width: "45%", align: "left" },
      { Header: "in/out", accessor: "inout", align: "center" },
      { Header: "admission no.", accessor: "admissionNo", align: "left" },
      { Header: "room", accessor: "room", align: "center" },
      { Header: "sem", accessor: "sem", align: "center" },
      { Header: "view profile", accessor: "viewProfile", align: "center" },
    ],

    rows: studentData,
  };
}
